import { useSearchParams } from 'react-router-dom';
import { AuthLayout } from '../components/AuthLayout';
import { useHandleGoogleCallback } from '../hooks/useHandleGoogleCallback';

export const Login = () => {
  const [searchParams] = useSearchParams();
  const code = searchParams.get('code');
  const error = searchParams.get('error');
  const { isLoading } = useHandleGoogleCallback(code, error);

  return <AuthLayout page="login" isGoogleCallbackLoading={isLoading} />;
};
